import { render, staticRenderFns } from "./ApplicantWarningTable.vue?vue&type=template&id=1f96a316&scoped=true&"
import script from "./ApplicantWarningTable.vue?vue&type=script&lang=ts&"
export * from "./ApplicantWarningTable.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicantWarningTable.vue?vue&type=style&index=0&id=1f96a316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f96a316",
  null
  
)

export default component.exports